<template>

    <div class="min-w-[320px]" :class="[
      isMobile && !$authenticated() ? 'pt-28 mb-24' : null,
      isMobile && $authenticated() ? 'pt-0 mb-24' : null,
      !isMobile && $authenticated() ? 'ml-72' : null,
      !isMobile && !$authenticated() ? 'mt-28' : null,
    ]">
        <WebsocketManager v-if="$authenticated()"/>

        <LiveSession/>

        <GoogleAnalytics/>

        <AhrefsAnalytics/>

        <FacebookPixel/>

        <Maintenance/>

        <ImageEditor v-if="imageEditorActive"/>

        <Dialog/>

        <InstallPrompt v-if="$store.state.ui.installPromptActive"/>

        <FeatureIdeaPrompt v-if="$authenticated()"/>

        <BugReportPrompt v-if="$authenticated()"/>

        <ChangelogModal v-if="$authenticated()"/>

        <SurveyPrompt v-if="$authenticated()"/>

        <Snackbar/>

        <div class="h-8 p-1 flex items-center justify-center bg-brand-primary-900 text-white text-sm fixed inset-0 bottom-auto z-50 font-bold" v-if="!$authenticated()">
            <div>
                X3 Log has been sunset: <a class="underline" href="https://v3me.io/x3-log">Read More</a>
            </div>
        </div>

        <Navbar class="h-20 fixed top-8 w-full z-50" v-if="!$authenticated()"/>

        <Sidebar v-if="$authenticated() && !isMobile"/>

        <router-view :key="$route.fullPath"/>

        <MobileMenu v-if="isMobile"/>

        <MobileTabs v-if="$authenticated() && isMobile"/>

    </div>

</template>

<script>
import {defineAsyncComponent} from 'vue';
import {mapActions} from 'vuex';

import Dialog from '@/components/Dialog.vue';
import InstallPrompt from '@/components/InstallPrompt.vue';
import Maintenance from '@/components/Maintenance.vue';
import MobileMenu from '@/components/MobileMenu';
import MobileTabs from '@/components/MobileTabs.vue';
import Navbar from '@/components/Navbar';
import Sidebar from '@/components/Sidebar.vue';
import Snackbar from '@/components/Snackbar.vue';
import ThemeSwitcher from '@/components/ThemeSwitcher';
import WebsocketManager from '@/components/WebsocketManager.vue';
import LiveSession from '@/components/LiveSession.vue';
import LogRocket from '@/components/LogRocket.vue';
import GoogleAnalytics from '@/components/GoogleAnalytics.vue';
import AhrefsAnalytics from '@/components/AhrefsAnalytics.vue';
import FacebookPixel from '@/components/FacebookPixel.vue';
import FeatureIdeaPrompt from '@/components/FeatureIdeaPrompt.vue';
import BugReportPrompt from '@/components/BugReportPrompt.vue';
import ChangelogModal from '@/components/ChangelogModal.vue';
import SurveyPrompt from '@/components/SurveyPrompt.vue';
import {captureUtmFromRoute} from '@/utils/utmTracking';

const isMobileThreshold = 768;
const ImageEditor = defineAsyncComponent(() => import('@/components/ImageEditor.vue'));

export default {
  name: 'App',
  components: {
    Dialog,
    ImageEditor,
    InstallPrompt,
    LiveSession,
    LogRocket,
    GoogleAnalytics,
    AhrefsAnalytics,
    FacebookPixel,
    FeatureIdeaPrompt,
    BugReportPrompt,
    ChangelogModal,
    SurveyPrompt,
    Maintenance,
    MobileMenu,
    MobileTabs,
    Navbar,
    Sidebar,
    Snackbar,
    ThemeSwitcher,
    WebsocketManager,
  },
  computed: {
    isMobile() {
      return this.$store.state.ui.isMobile;
    },
    imageEditorActive() {
      return this.$store.state.ui.imageEditor.active;
    },
    settings() {
      return this.$store.state.system.settings;
    },
  },
  async created() {

    this.setIsMobile(window.innerWidth < isMobileThreshold);
    window.addEventListener('resize', this.windowResize);

    this.systemStatus();
    this.heartbeat = setInterval(this.systemStatus, 60 * 1000);
  },
  mounted() {
    // Capture UTM parameters on initial mount
    if (this.$route) {
      captureUtmFromRoute(this.$route);
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.windowResize);
    clearInterval(this.heartbeat);
  },
  data() {
    return {
      heartbeat: null,
    };
  },
  methods: {
    ...mapActions({
      setIsMobile: 'ui/isMobile',
      systemStatus: 'system/index',
    }),
    windowResize(event) {
      let windowWidth = event.target.innerWidth;
      this.setIsMobile(windowWidth < isMobileThreshold);
    }
  },
  watch: {
    'settings.theme': {
      immediate: true,
      handler() {
        if (this.settings.theme === 'dark') {
          document.documentElement.classList.add('dark');
        } else {
          document.documentElement.classList.remove('dark');
        }
      },
    },
  },
};
</script>

<style>

</style>
